import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 */
export class InstantOfferSellerEntity extends Entity {
  /**
   * @param {Object}  deps
   * @param {Object}  deps.appraisal
   * @param {Object}  deps.appraisal.minPrice
   * @param {String}  deps.appraisal.minPrice.currency
   * @param {Number}  deps.appraisal.minPrice.value
   * @param {Object}  deps.appraisal.maxPrice
   * @param {String}  deps.appraisal.maxPrice.currency
   * @param {Number}  deps.appraisal.maxPrice.value
   * @param {Object}  deps.appraisal.priceRecommended
   * @param {String}  deps.appraisal.priceRecommended.currency
   * @param {Number}  deps.appraisal.priceRecommended.value
   * @param {String}  deps.instantOfferId
   * @param {String}  deps.photoUrl
   * @param {Number}  deps.postalCode
   * @param {String}  deps.title
   * @param {Object}  deps.vehicle
   * @param {Object}  deps.vehicleData
   * @param {String}  deps.vehicleData.licensePlate
   */

  getId() {
    return this._instantOfferId
  }
}
